import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Form } from 'react-bootstrap';
import { ConfirmDialog } from '../../common/Utilities';
import { togglePrompt } from '../../store/actions/commonActions';
import { approveProject, rejectProject, addRemarks, fetchForApprovals } from '../../store/actions/projects/projectApprovals';

class ProjectConfirmations extends Component {

  render() {
    const remarksId = "remarks";

    let modalTitle = '';
    let modalBody = '';
    let onHideFunction = {}
    let onClickCancel = {}
    let onClickConfirm = {}
    let specialForm = '';

    let isRemarksRequired = true;

    switch (this.props.confirmAction) {
      case 'APPROVE_PROJECT':
        modalTitle = 'Approve Project';
        if (this.props.projectName) {
          modalTitle = modalTitle + ": " + this.props.projectName;
        }
        
        modalBody = 'Are you sure you want to approve this project?';
        
        onClickConfirm = () => {
          this.props.approveProject(this.props.projectId, () => {
            this.props.togglePrompt(false);
            this.props.history.push('/approvals');
            this.props.fetchForApprovals();
          }, () => {
            this.props.togglePrompt(false);
            this.props.history.push('/approvals');
          });
        }

        specialForm = <>
          <Row className="mt-3">
            <Col>
              <Form>
                <Form.Group>
                  <Form.Label>Remarks: (Optional)</Form.Label>
                  <Form.Control 
                    as="textarea" 
                    rows="3" 
                    id={remarksId} 
                    onChange={this.props.addRemarks}/>
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </>
        
        isRemarksRequired = false;

        break;
      case 'REJECT_PROJECT':
        modalTitle = 'Reject Project';
        if (this.props.projectName) {
          modalTitle = modalTitle + ": " + this.props.projectName;
        }

        modalBody = 'Are you sure you want to reject this project?';
        
        // onClickConfirm = () => {
        //   this.props.rejectProject(this.props.projectId, () => {
        //     this.props.togglePrompt(false);
        //     this.props.fetchForApprovals();
        //     this.props.history.push('/approvals');
        //   });
        // }

        onClickConfirm = () => {
          this.props.rejectProject(this.props.projectId, () => {
            this.props.togglePrompt(false);
            this.props.history.push('/approvals');
            this.props.fetchForApprovals();
          }, () => {
            this.props.togglePrompt(false);
            this.props.history.push('/approvals');
          });
        }

        specialForm = <>
          <Row className="mt-3">
            <Col>
              <Form>
                <Form.Group>
                  <Form.Label>Remarks: <i style={{fontSize: "0.75em"}}>(Atleast 10 characters)</i></Form.Label>
                  <Form.Control 
                    as="textarea" 
                    rows="3" 
                    id={remarksId} 
                    onChange={this.props.addRemarks}/>
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </>

        break;
      default: 
        break;
    }

    onHideFunction = () => {
      this.props.togglePrompt(false);
    }

    onClickCancel = () => {
      this.props.togglePrompt(false);
    }

    if (!modalTitle) {
      return '';
    }

    return (
      <ConfirmDialog 
        show={this.props.common.togglePrompt} 
        modalTitle={modalTitle} 
        modalBody={modalBody} 
        onHideFunction={onHideFunction}
        onClickCancel={onClickCancel}
        onClickConfirm={onClickConfirm} 
        specialForm={specialForm}
        remarksId={remarksId} 
        remarksRequired={isRemarksRequired}  
      />
    ) 
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  common: state.common 
})

const mapDispatchToProps = (dispatch) => {
  return {
    togglePrompt: (...args) => dispatch(togglePrompt(...args)), 
    approveProject: (...args) => dispatch(approveProject(...args)),
    rejectProject: (...args) => dispatch(rejectProject(...args)),
    fetchForApprovals: () => dispatch(fetchForApprovals()), 
    addRemarks: (...args) => dispatch(addRemarks(...args))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectConfirmations))
